module.exports = __webpack_public_path__ + "static/media/bg_qy2.4f422bdb.png";